<ion-header class="ion-no-border page">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/dashboard"></ion-back-button>
    </ion-buttons>
    <ion-title mode="ios">
      <div  (click)="goHome()" class="header-logo">&nbsp;</div>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="showMenu()" class="menu" [attr.aria-label]="'ARIA.MENU.BUTTON.LABEL_0' | translate">
        <ion-icon slot="icon-only" aria-hidden="true"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="page-title" translate>BADGE.TITLE</div>

</ion-header>

<ion-content class="ion-padding" no-bounce>

  <ng-template [ngIf]="isLoading">
    <div class="v-box full-width full-height justify-around align-center">
      <ion-spinner color="dark"></ion-spinner>
    </div>
  </ng-template>
  <ng-template [ngIf]="!isLoading && !hasBadges">
    <div class="no-entries-label" translate>BADGE.NO_ENTRIES</div>
  </ng-template>

  <ng-template [ngIf]="hasBadges">
    <ion-grid>
      <ion-row>
        <ion-col *ngFor="let badge of badges" size="6" size-sm="6" size-md="6" size-lg="4" size-xl="3">
          <button class="leada-badge" [ngClass]="getBadgeClass(badge)" (click)="showBadge(badge)">
            <badge-image [badge]="badge"></badge-image>
            <div>
              {{getLocalizedBadgeText(badge.title)}}
            </div>
            <ion-badge *ngIf="isNew(badge)" translate class="badge">BADGE.NEW</ion-badge>
          </button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ng-template>

</ion-content>
